import { Button, Card, CircularProgress, Grid, IconButton, InputLabel, Tooltip } from '@material-ui/core';
import { InfoOutlined, VisibilityOutlined } from '@material-ui/icons';
import React, { useEffect, useState } from 'react';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import Swal from 'sweetalert2';

import { ModalPreviewSec, UploadImage } from '../../../../components';
import { getDevelopmentData, updDevelopmentData } from '../../../../redux/actions/SejarahActions';

const Konten = () => {
  const [submit, setSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPreviewSec, setShowPreviewSec] = useState(null)
  const [params, setParams] = useState({
    data: [],
  });
  const handleChange = ({ target: { value, name } }, index) => {
    let data = params.data;
    let item = data[index];
    item = {
      ...item,
      [name]: value,
    };
    data[index] = item;
    setParams((pref) => ({
      ...pref,
      data: data,
    }));
  };
  const handleFormSubmit = () => {
    setSubmit(true);
    updDevelopmentData(params)
      .then(() => {
        showAlert("Data berhasil disimpan", true);
        setSubmit(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal menyimpan data, coba beberapa saat lagi",
          false
        );
        setSubmit(false);
      });
  };
  const showAlert = (text, success) => {
    Swal.fire({
      title: success ? "Berhasil" : "Oopss!",
      text: text,
      imageUrl: `/assets/images/icons/${
        success ? "ic_success" : "ic_error"
      }.svg`,
      imageWidth: 92,
      imageHeight: 92,
      confirmButtonText: "Ok",
      confirmButtonColor: "#0083E2",
    });
  };
  const getData = () => {
    setLoading(true);
    getDevelopmentData()
      .then((res) => {
        let data = res.data?.data;
        if (Object.keys(data).length > 0) {
          setParams((pref) => ({
            ...pref,
            data: data,
          }));
        } else {
          showAlert("Gagal mengambil data, coba beberapa saat lagi", false);
        }
        setLoading(false);
      })
      .catch((err) => {
        let error = err?.response?.data;
        showAlert(
          Array.isArray(error?.data)
            ? error?.data[0]
            : "Gagal mengambil data, coba beberapa saat lagi",
          false
        );
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, []);

  const handleChangeFoto = (file, path, index) => {
    let data = params.data;
    data[index].img_preview = path;
    data[index].img = file;
    setParams((pref) => ({
      ...pref,
      data: data,
    }));
  };

  return (
    <div className="m-sm-30">
      <Grid container spacing={4} justifyContent="center">
        <Grid item xs={11} md={12}>
          <h3 className="fw-bold m-0">Sejarah Perusahaan - Konten</h3>
        </Grid>
        <Grid item xs={11} md={12}>
          <Card elevation={0} className="p-5">
            {loading ? (
              <div className="text-center">
                <CircularProgress color="primary" size={35} />
              </div>
            ) : (
              <ValidatorForm onSubmit={handleFormSubmit} className="w-full">
                {params?.data.map((item, index) => (
                  <>
                    <h4 className="fw-bold mb-5 mt-10">Bagian {index + 1} <IconButton onClick={() => setShowPreviewSec(`/assets/images/illustrations/sejarah_${index + 1}.png`)} size='small'><VisibilityOutlined fontSize='small' color='action'></VisibilityOutlined></IconButton></h4>
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        <UploadImage
                          uploadFoto={(file, path) =>
                            handleChangeFoto(file, path, index)
                          }
                          label="Unggah Foto"
                          preview={item.img_preview}
                          required={true}
                          noCrop
                          note={[
                            "Format PNG, WEBP dan JPG diperbolehkan",
                            index
                              ? "*Ukuran foto 1440 x 715"
                              : "*Ukuran foto 736 x 759",
                          ]}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel htmlFor="title_id" className="mb-4">
                          Judul [ID] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_id"
                          placeholder="Judul"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChange(e, index)}
                          type="text"
                          name="title_id"
                          value={item.title_id || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Judul terlebih dahulu"]}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel htmlFor="title_en" className="mb-4">
                          Judul [EN] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="title_en"
                          placeholder="Judul"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChange(e, index)}
                          type="text"
                          name="title_en"
                          value={item.title_en || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan Judul terlebih dahulu"]}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel htmlFor="desc_id" className="mb-4">
                          Deskripsi [ID] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Indonesia pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="desc_id"
                          placeholder="Deskripsi"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChange(e, index)}
                          type="text"
                          name="desc_id"
                          value={item.desc_id || ""}
                          validators={["required"]}
                          errorMessages={[
                            "Masukkan deskripsi terlebih dahulu",
                          ]}
                          multiline
                          maxRows={16}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <InputLabel htmlFor="desc_en" className="mb-4">
                          Deskripsi [EN] <span className="text-danger">*</span>
                          <Tooltip
                            title="Teks Akan ditampilkan saat pengguna menggunakan bahasa Inggris pada website"
                            placement="top-start"
                            arrow
                          >
                            <InfoOutlined
                              fontSize="small"
                              color="action"
                            ></InfoOutlined>
                          </Tooltip>
                        </InputLabel>
                        <TextValidator
                          id="desc_en"
                          placeholder="deskripsi"
                          className="w-full"
                          variant="outlined"
                          onChange={(e) => handleChange(e, index)}
                          type="text"
                          name="desc_en"
                          value={item.desc_en || ""}
                          validators={["required"]}
                          errorMessages={["Masukkan deskripsi terlebih dahulu"]}
                          multiline
                          maxRows={16}
                        />
                      </Grid>
                    </Grid>
                  </>
                ))}

                <Grid item xs={12}>
                  <Grid
                    container
                    spacing={2}
                    justifyContent="flex-end"
                    className="flex-column-reverse flex-md-row mt-20"
                  >
                    <Grid item xs={12} md={2}>
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        className="text-white w-full radius-6 text-capitalize py-2"
                        disableElevation
                        disabled={submit}
                      >
                        {submit ? (
                          <CircularProgress color="primary" size={25} />
                        ) : (
                          "Simpan Data"
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            )}
          </Card>
        </Grid>
      </Grid>
      <ModalPreviewSec handleClose={() => setShowPreviewSec(null)} img={showPreviewSec} open={showPreviewSec} />
    </div>
  );
};

export default Konten;
